import classNames from 'clsx';
import format from 'date-fns/format';
import React, { FC, memo } from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';

import styles from '../DataListItemRow.css';

interface DateProps {
    date?: number;
    isWide?: boolean;
    hide?: boolean;
}

export const Date: FC<DateProps> = memo(function Date({ date, isWide, hide }) {
    return (
        <div
            className={classNames(styles.date, {
                [styles.date_wide]: isWide,
                [styles.date_hide]: hide,
                [styles.dateResponsive]: ENABLE_FULL_RESPONSIVE,
            })}
        >
            {!!date && format(date, 'dd.MM.yy HH:mm')}
        </div>
    );
});
